<script setup lang="ts">
import { CarFront, DoorClosed, ArrowUpDown, User } from "lucide-vue-next";
import { dropoffOptions } from "@lib/zod/userAddressSchema";
import { type Component } from 'vue';
import WalkingIcon from "@/ui-plus/icons/WalkingIcon.vue";

defineProps<{
    option: (typeof dropoffOptions)[number];
}>();

const dropoffOptionsConfig: Record<typeof dropoffOptions[number], { label: string, icon: Component }> = {
    MEET_AT_DOOR: {
        label: 'Meet at Door', icon: User
    },
    MEET_AT_CURBSIDE: {
        label: 'Meet at Curbside', icon: CarFront
    },
    LEAVE_AT_DOOR: {
        label: 'Leave at Door', icon: DoorClosed
    },
    LEAVE_AT_LOBBY: {
        label: 'Leave at Lobby', icon: ArrowUpDown
    },
};
</script>

<template>
    <div class="flex items-center justify-center">
        <component :is="dropoffOptionsConfig[option].icon"
                   class="h-10 w-10"
                   :class="{ 'border-b-3 border-foreground': option === 'MEET_AT_CURBSIDE' }" />
        <div class="border-b-8 border-foreground h-10 w-2"
             v-if="option === 'MEET_AT_CURBSIDE'">
            <WalkingIcon class="h-8 w-8"
                         style="transform: scaleX(-1) translateX(7px)" />
        </div>
    </div>
    <span class="text-xs text-center leading-tight">
        {{ dropoffOptionsConfig[option].label }}
    </span>
</template>